import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/shared/services/toast.service';
import { IListByFilterDevices, IDevice, ICreateDevice, IKioskRegistration } from '../models/device.interface';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';

@Injectable({
  providedIn: 'root'
})
export class DeviceService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}Device`;

  constructor(
    private readonly http: HttpClient,
    protected readonly toast: ToastService
  ) {
    super(toast);
  }

  listDevices(filter: IListByFilterDevices): Observable<ResponseDefault<IDevice[]>> {
    let params = new HttpParams().appendAll({
      pageNumber: filter.pageNumber.toString(),
      pageSize: filter.pageSize.toString(),
      orderBy: filter.orderBy.toString()
    });

    if (filter.companyId) {
      params = params.append('companyId', filter.companyId);
    }
    if (filter.active != null) {
      params = params.append('active', String(filter.active));
    }
    if (filter.searchText) {
      params = params.append('searchText', filter.searchText);
    }

    return this.http.get<ResponseDefault<IDevice[]>>(`${this.apiUrl}/ListByFilterAsync`, { params });
  }

  addDevice(device: ICreateDevice): Observable<ResponseDefault<IDevice>> {
    return this.http.post<ResponseDefault<IDevice>>(`${this.apiUrl}`, device);
  }

  getDeviceById(id: string): Observable<ResponseDefault<IDevice>> {
    return this.http.get<ResponseDefault<IDevice>>(`${this.apiUrl}/${id}`);
  }

  updateDevice(id: string, device: IDevice): Observable<ResponseDefault<IDevice>> {
    return this.http.put<ResponseDefault<IDevice>>(`${this.apiUrl}/${id}`, device);
  }

  getActiveDevicesByCompany(companyId: string): Observable<ResponseDefault<IDevice[]>> {
    return this.http.get<ResponseDefault<IDevice[]>>(`${this.apiUrl}/GetActiveDevicesByCompany/${companyId}`);
  }

  ativarDevice(id: string): Observable<ResponseDefault<boolean>> {
    return this.http.put<ResponseDefault<boolean>>(`${this.apiUrl}/SetActiveAsync/${id}`, {});
  }

  desativarDevice(id: string): Observable<ResponseDefault<boolean>> {
    return this.http.put<ResponseDefault<boolean>>(`${this.apiUrl}/SetInactiveAsync/${id}`, {});
  }

  listKioskRegistrations(companyId?: string): Observable<ResponseDefault<IKioskRegistration[]>> {
    let params = new HttpParams();
    if (companyId) {
      params = params.append('companyId', companyId);
    }
    return this.http.get<ResponseDefault<IKioskRegistration[]>>(`${this.apiUrl}/kiosk-registrations`, { params });
  }

  revokeKioskRegistration(id: string): Observable<ResponseDefault<boolean>> {
    return this.http.delete<ResponseDefault<boolean>>(`${this.apiUrl}/${id}/kiosk-registration`);
  }
}
